export default function(a, b) {
  return a = +a, b -= a, function(t) {
    return Math.round(a + b * t);
  };
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-interpolate/src/round.js
// module id = 963
// module chunks = 1